import { ResponseError } from '@ynap/api-utils';
import { SubmissionError } from 'redux-form';

export default function submitAndCollateErrors(values, dispatch, props) {
    const { onSubmit, collateErrors } = props;
    return submitAndCollateErrorsPromise(onSubmit(values), values, props);
}

export function submitAndCollateErrorsPromise(promise, values, props) {
    const { collateErrors, optimizely } = props;

    return promise.catch((error) => {
        if (error.name === ResponseError.name) {
            const { response } = error;
            return response
                .json()
                .catch()
                .then((json) => {
                    const event =
                        json?.errors && json?.errors[0]?.errorKey === '_ERR_LOGONID_ALREDY_EXIST'
                            ? 'oc_registration_fail_existing'
                            : 'oc_registration_fail_other';
                    optimizely?.track(event);
                    throw new SubmissionError(collateErrors(values, props, json));
                });
        }
        throw new SubmissionError(collateErrors(values, props));
    });
}
